import React from 'react'
import PropTypes from 'prop-types'
import 'material-icons/iconfont/outlined.css'
import TextWithCard from './TextWithCard'

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    jussifyContent: 'space-between',
    width: '100%',
    gap: 20
  },

}

const DoubleTextWithCard = ({
  text, title, text2, title2, showSecondCard
}) => (
  <div style={styles.container}>
    <TextWithCard text={text} title={title} />
    {showSecondCard
      && <TextWithCard text={text2} title={title2} />}
  </div>
)

DoubleTextWithCard.propTypes = {
  text: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  text2: PropTypes.string.isRequired,
  title2: PropTypes.string.isRequired,
  showSecondCard: PropTypes.bool
}

DoubleTextWithCard.defaultProps = {
  showSecondCard: true
}

export default DoubleTextWithCard
